import { UserInfo } from "@/types/entity";
import apiClient from "../apiClient";
import { adminLoginUrl, adminUserInfoUrl, exchangeListUrl, generateMfaSecretUrl, resetPasswordUrl, saveMfaSecretUrl, sendCodeUrl, unbindUrl, verifyCodeUrl } from '../apis';

import { HttpResponse } from '../typings';

export interface SignInReq {
	username: string;
	password: string;
	mfaCode?: string;
}

export interface ResetPwdReq {
	oldPassword: string;
	newPassword: string;
	mfaCode?: string;
}
export type SignInRes = {
	username: string;
	forceChangePassword: boolean;
	token: string;
	verified: boolean;
	needMfa?: boolean;
};

const signin = (data: SignInReq) =>
	apiClient.post<HttpResponse<SignInRes>>({ url: adminLoginUrl, data }).then(res => ({ ...res.value, username: data.username }));

export const resetPassword = (data: ResetPwdReq) =>
	apiClient.post<HttpResponse<{ needMfa: boolean, result: boolean }>>({ url: resetPasswordUrl, data }).then(res => res.value);

export const getUserInfo = () =>
	apiClient.get<HttpResponse<UserInfo>>({ url: adminUserInfoUrl }).then(res => res.value);

export const sendCode = (data: { email: string }) => 
	apiClient.post<HttpResponse>({ url: sendCodeUrl, data: { ...data, type: 'BIND_MFA' } }).then(res => res.value);

export const verifyCode = (data: { email: string, captcha: string }) => 
	apiClient.post<HttpResponse>({ url: verifyCodeUrl, data: { ...data, type: 'BIND_MFA' } }).then(res => res.value);

export const generateMfaSecret = (data: { email: string, captcha: string }) => 
	apiClient.post<HttpResponse>({ url: generateMfaSecretUrl, data }).then(res => res.value);

export const saveMfaSecret = (data: { mfaCode: string } ) => 
	apiClient.post<HttpResponse>({ url: saveMfaSecretUrl, data }).then(res => res.value);

export const unbindMfa = (data: { password: string, mfaCode: string }) => 
	apiClient.post<HttpResponse>({ url: unbindUrl, data }).then(res => res.value);

export const getExchangeList = () => 
	apiClient.get<HttpResponse<string[]>>({ url: exchangeListUrl }).then(res => res.value);

export default {
	signin,
};
